import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["center", "children"];
import { createElementObject, createPathComponent, extendContext, updateCircle } from '@react-leaflet/core';
import { Circle as LeafletCircle } from 'leaflet';
export var Circle = createPathComponent(function createCircle(_ref, ctx) {
  var center = _ref.center,
    _c = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  var circle = new LeafletCircle(center, options);
  return createElementObject(circle, extendContext(ctx, {
    overlayContainer: circle
  }));
}, updateCircle);